require('./portableProductsAccordion.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const PortableProductDetailAccordion = require('components/myProfile/portableProductDetailAccordion/portableProductDetailAccordion');

// @constants
const {
    CARD_ECARD,
    CARD_CREDIT,
    CARD_DEBIT,
    MY_PROFILE_ACCOUNT,
    WALLETS,
    FUNDS,
    PLANS,
    MORTGAGES,
    LOANS,
} = require('constants/index');

// @ helpers
const rightsProfileHelper = require('utilities/rightsProfileHelper');

class PortableProductsAccordion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            doActionChangeALl: props.doActionChangeALl,
            allChecksHeadersStatus: props.allChecksHeadersStatus
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            doActionChangeALl: nextProps.doActionChangeALl,
            allChecksHeadersStatus: nextProps.allChecksHeadersStatus
        });
    }

    // Build different accordion by products.

    buildAccordion(type, idType) {
        const {
            immPlans,
            immAccounts,
            immCards,
            immFunds,
            immWallets,
            onUpdateList,
            immRightsProfile,
            selectFilter,
            immWalletSummarization,
            immLoans
        } = this.props;

        const { doActionChangeALl, allChecksHeadersStatus } = this.state;

        let product;
        let saveList;
        let changeListFunc = onUpdateList ;

        switch (type) {
            case WALLETS:
                product = immWallets;
                saveList = immRightsProfile.get('walletsList').size === 0 ? immRightsProfile.get('walletsList').toJS() : immRightsProfile.get('walletsList');
                break;
            case FUNDS:
                product = immFunds;
                saveList = immRightsProfile.get('fundsList').size === 0 ? immRightsProfile.get('fundsList').toJS() : immRightsProfile.get('fundsList');
                break;
            case CARD_ECARD:
                product = immCards;
                saveList = immRightsProfile.get('cardEcardList').size === 0 ? immRightsProfile.get('cardEcardList').toJS() : immRightsProfile.get('cardEcardList');
                break;
            case PLANS:
                product = immPlans;
                saveList = immRightsProfile.get('plansList').size === 0 ? immRightsProfile.get('plansList').toJS() : immRightsProfile.get('plansList');
                break;
            case MY_PROFILE_ACCOUNT:
                product = immAccounts;
                saveList = immRightsProfile.get('accountList').size === 0 ? immRightsProfile.get('accountList').toJS() : immRightsProfile.get('accountList');
                break;
            case CARD_CREDIT:
                product = immCards;
                saveList = immRightsProfile.get('cardCreditList').size === 0 ? immRightsProfile.get('cardCreditList').toJS() : immRightsProfile.get('cardCreditList');
                break;
            case CARD_DEBIT:
                product = immCards;
                saveList = immRightsProfile.get('cardDebitList').size === 0 ? immRightsProfile.get('cardDebitList').toJS() : immRightsProfile.get('cardDebitList');
                break;
            case MORTGAGES:
                product = rightsProfileHelper.loansWithBalanceBiggerThanCero(true, false, immLoans);
                saveList = immRightsProfile.get('mortgagesList').size === 0 ? immRightsProfile.get('mortgagesList').toJS() : immRightsProfile.get('mortgagesList');
                break;
            case LOANS:
                product = rightsProfileHelper.loansWithBalanceBiggerThanCero(false, false, immLoans);
                saveList = immRightsProfile.get('loansList').size === 0 ? immRightsProfile.get('loansList').toJS() : immRightsProfile.get('loansList');
                break;
        }

        return (
            <PortableProductDetailAccordion
                product={product}
                type={type}
                idType={idType}
                changeListFunc={changeListFunc}
                saveList={saveList}
                allChecksHeadersStatus={allChecksHeadersStatus}
                doActionChangeALl={doActionChangeALl}
                showMovements={immRightsProfile.get('showMovements')}
                selectFilter={selectFilter}
                immWalletSummarization={immWalletSummarization}
            />
        );
    }

    render() {
        const { immAccounts, immFunds, immWallets, immPlans, immLoans, immCards } = this.props;
        const accounts = (immAccounts.get('byOrder').size) ? this.buildAccordion(MY_PROFILE_ACCOUNT, 'accounts') : null;
        const plans = (immPlans.size) ? this.buildAccordion(PLANS, 'plans') : null;
        const credit = (rightsProfileHelper.getTotalCardsByType(CARD_CREDIT, immCards)) ? this.buildAccordion(CARD_CREDIT, 'creditCard') : null;
        const debit = (rightsProfileHelper.getTotalCardsByType(CARD_DEBIT, immCards)) ? this.buildAccordion(CARD_DEBIT, 'debitCard') : null;
        const ecard = (rightsProfileHelper.getTotalCardsByType(CARD_ECARD, immCards)) ? this.buildAccordion(CARD_ECARD, 'ecard') : null;
        const wallets = (immWallets.size) ? this.buildAccordion(WALLETS, 'wallets') : null;
        const funds = (immFunds.size) ? this.buildAccordion(FUNDS, 'funds') : null;
        const mortgages = rightsProfileHelper.loansWithBalanceBiggerThanCero(true, true, immLoans) ? this.buildAccordion(MORTGAGES, 'mortgages') : null;
        const loans = rightsProfileHelper.loansWithBalanceBiggerThanCero(false, true, immLoans) ? this.buildAccordion(LOANS, 'loans') : null;

        return (
            <div className="portable-products-accordion">
                {accounts}
                {funds}
                {plans}
                {wallets}
                {mortgages}
                {loans}
                {credit}
                {debit}
                {ecard}
            </div>
        );
    }
}


PortableProductsAccordion.propTypes = {
    immCards: PropTypes.bool,
    immLoans: PropTypes.bool,
    immAccounts: PropTypes.func,
    immPlans: PropTypes.obj,
    immFunds: PropTypes.obj,
    immWallets: PropTypes.obj,
    onUpdateList: PropTypes.func,
    immRightsProfile: PropTypes.obj,
    allChecksHeadersStatus: PropTypes.bool,
    selectFilter: PropTypes.string,
    doActionChangeALl: PropTypes.bool,
    immWalletSummarization: PropTypes.obj
};

module.exports = PortableProductsAccordion;
